import { appLocalStorage } from '@/app/shared/commonURLs';


let PatientProblemUrl = appLocalStorage.PatientProblemURL;
let PatientProblemODataUrl = appLocalStorage.PatientProblemOdataURL;
let MedicalsetupOdataUrl = appLocalStorage.MedicalsetupOdataUrl;
let CpoeUrl = appLocalStorage.CpoeUrl;

export class uRls {
    constructor() {
        this.PatientProblemServicesList = PatientProblemURLs();
        this.CpoeServicesList = CpoeURls();

    }
}
const PatientProblemURl = new uRls();
const CpoeURL = new uRls();
export { PatientProblemURl, CpoeURL };

function PatientProblemURLs() {

    var services = {};

    services["GetChiefComplaintByVisitID"] = {
        Method: 'Get',
        URL: PatientProblemUrl + 'ChiefComplaint/GetChiefComplaintByVisitID'
    },
        services["AddChiefComplaint"] = {
            Method: 'POST',
            URL: PatientProblemUrl + 'ChiefComplaint/AddChiefComplaint',
        },
        services["GetChiefComplaintHistoryOdata"] = {
            Method: 'Get',
            URL: PatientProblemODataUrl + 'ChiefComplaintHistoryOdata?',
        },
        services["DeleteChiefComplaint"] = {
            Method: 'POST',
            URL: PatientProblemUrl + 'ChiefComplaint/DeleteChiefComplaint',
        },

        services["GetDiagnosisList"] = {
            Method: 'Get',
            URL: PatientProblemODataUrl + 'DiagnosisListOdata?'
        },
        services["getStaticData"] = {
            Method: 'Get',
            URL: PatientProblemUrl + 'PatientProblem/getStaticData'
        },
        services["GetDiagnosisSubGridList"] = {
            Method: 'Get',
            URL: PatientProblemUrl + 'PatientProblem/getProblemCardDetailByDiagnosisID'
        },
        services["GetVisitDiagnosisList"] = {
            Method: 'Get',
            URL: PatientProblemODataUrl + 'VisitDiagnosisListOdata?'
        },
        services["AddDiagnosis"] = {
            Method: 'POST',
            URL: PatientProblemUrl + 'PatientProblem/Add',
        },
        services["GetDiseaseList"] = {
            Method: 'Get',
            URL: PatientProblemODataUrl + 'DiseaseOData?'
        },
        services["DeleteDignosis"] = {
            Method: 'POST',
            URL: PatientProblemUrl + 'PatientProblem/DeleteDignosis',
        },
        services["GetPhyscianDiagnoses"] = {
            Method: 'Get',
            URL: PatientProblemODataUrl + 'PhyscianDiagnosisOdata?'
        },
        services["GetSpectialityDiagnoses"] = {
            Method: 'Get',
            URL: PatientProblemODataUrl + 'SpectialityDiagnosesOdata?'
        }

    services["DeleteFavouritPhyscianDignosis"] = {
        Method: 'POST',
        URL: PatientProblemUrl + 'FavouritDiagnoses/DeleteFavouritPhyscianDignosis',
    },
        services["UpdateDiagnosis"] = {
            Method: 'PUT',
            URL: PatientProblemUrl + 'PatientProblem/Update',
        },
        services["GetPhyscianChiefComplaintOdata"] = {
            Method: 'Get',
            URL: PatientProblemODataUrl + 'PhyscianChiefComplaintOdata?',
        },
        services["GetDignosisDDLsData"] = {
            Method: 'Get',
            URL: PatientProblemUrl + 'PatientProblem/GetDignosisDDLsData'
        },

        services["AddFavouritPhyscian"] = {
            Method: 'POST',
            URL: PatientProblemUrl + 'FavouritDiagnoses/AddFavouritPhyscian',
        },
        services["DeleteFavouritSpecialityDignosis"] = {
            Method: 'POST',
            URL: PatientProblemUrl + 'FavouritDiagnoses/DeleteFavouritSpecialityDignosis',
        },
        services["AddPhyscianChiefComplaint"] = {
            Method: 'POST',
            URL: PatientProblemUrl + 'ChiefComplaint/AddPhyscianChiefComplaint',
        },
        services["EditPhyscianChiefComplaint"] = {
            Method: 'PUT',
            URL: PatientProblemUrl + 'ChiefComplaint/EditPhyscianChiefComplaint',
        },
        services["DeletePhyscianChiefComplaint"] = {
            Method: 'Delete',
            URL: PatientProblemUrl + 'ChiefComplaint/DeletePhyscianChiefComplaint',
        },
        services["GetAllDiseaseList"] = {
            Method: 'Get',
            URL: PatientProblemODataUrl + 'AllDiseaseOData?'
        }
    //services["GetAllDiseaseList"] = {
    //    Method: 'Get',
    //    URL: PatientProblemUrl + 'AllDiseaseOData?'
    //    },

    services["GetSpcialities"] = {
        Method: 'Get',
        URL: MedicalsetupOdataUrl + 'SpecialityOData?'
    },
        services["AddFavouritSpectiality"] = {
            Method: 'POST',
            URL: PatientProblemUrl + 'FavouritDiagnoses/AddFavouritSpectiality',
        },
        services["EditFavouritSpectiality"] = {
            Method: 'PUT',
            URL: PatientProblemUrl + 'FavouritDiagnoses/EditFavouritSpectiality',
        }

    services["GetCurrentPhysicanId"] = {
        Method: 'Get',
        URL: PatientProblemUrl + 'ChiefComplaint/GetCurrentPhysicanId',
    }
    return services
}



function CpoeURls() {
    var services = {};
    services["CheckIfDiagnosisHasTreatmentPlan"] = {
        Method: 'Get',
        URL: CpoeUrl + 'TreatmentPlan/CheckIfDiagnosisHasTreatmentPlan',
    }

    return services;
}




